import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export function generateRopReport(_x) { return _generateRopReport.apply(this, arguments); }
function _generateRopReport() { _generateRopReport = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(req) { return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch("/api/v1/report/generateRopReport", { method: "post", headers: { "Content-Type": "application/json" }, body: JSON.stringify(Object.assign({}, req)) }).then(function (v) { return v.blob(); }).then(function (blob) { var b = new Blob([blob], { type: "application/pdf" }); var dataUrl = window.URL.createObjectURL(b); return dataUrl; });
        case 3: return _context.abrupt("return", _context.sent);
        case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", null);
        case 9:
        case "end": return _context.stop();
    }
} }, _callee, null, [[0, 6]]); })); return _generateRopReport.apply(this, arguments); }
